import Header from "@/components/entities/header";
import { useTranslations } from "use-intl";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import Title from "@/components/ui/title";
import ImageTextBlock from "@/components/ui/image-text-block";

const HeaderAcademy = () => {
  const t = useTranslations("academy");

  return (
    <div className={S.borderWrapper}>
      <Header />
      <ImageTextBlock image="/images/academy/header.png">
        <div className={S.content}>
          <h1 className={S.title}>{t("slogan")}</h1>
        </div>
      </ImageTextBlock>
      <Container className={S.headerWrapper}>
        <Title>{t("title")}</Title>
      </Container>
    </div>
  );
};

export default HeaderAcademy;
